import modular from 'stereomodularjs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import './utils/events';

const app = new modular({
    modules: modules
});

window.onload = (event) => {
    const $style = document.getElementById('main-css');
    classAdd(document.querySelector('body'), 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace'))

    if ($style) {
        if ($style.isLoaded){
            init();
        } else {
            $style.addEventListener('load', (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }

    let isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;

    if(window.isMobile) {
        html.classList.add('is-mobile');
    }
};

function init() {
    globals();

    app.init(app);

    setTimeout(() => {
        html.classList.add('is-first-loaded');

        let preventChilds = document.querySelectorAll('.js-prevent-childs a');
        preventChilds.forEach(el => {
            el.classList.add('js-prevent');
        });

    }, 50);

    setTimeout(() => {
        html.classList.add('is-loaded');
        html.classList.add('dom-is-loaded');
        html.classList.remove('is-loading');
    }, 800);
}

// Test 

// function onLoad() {
//     // add listeners for system color-change events.
//     window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", e => e.matches && activateDarkTheme());
//     window.matchMedia("(prefers-color-scheme: light)").addEventListener("change", e => e.matches && activateLightTheme());

//     // check local storage for explicit theme preference, else check system.
//     if (localStorage.getItem("theme") === "dark") {
//         activateDarkTheme();
//         console.log("Your browser is set to dark theme.");
//     } else if (localStorage.getItem("theme") === "light") {
//         activateLightTheme();
//         console.log("Your browser is set to light theme.");
//     } else {
//         activateColorScheme();
//     }
// }

// function activateTheme(theme) {
//     localStorage.setItem("theme", theme);
//     document.documentElement.setAttribute("theme", theme);
// }

// function activateDarkTheme() {
//     activateTheme("dark");
// }

// function activateLightTheme() {
//     activateTheme("light");
// }

// function activateColorScheme() {
//     const isDarkTheme = window.matchMedia("(prefers-color-scheme: dark)").matches;
//     const isLightTheme = window.matchMedia("(prefers-color-scheme: light)").matches;
//     const isNotSpecified = window.matchMedia("(prefers-color-scheme: no-preference)").matches;
//     const isNotSupported = !isDarkTheme && !isLightTheme && !isNotSpecified;

//     if (isDarkTheme) activateDarkTheme();
//     if (isLightTheme) activateLightTheme();
//     if (isNotSpecified) {
//         console.log("Your browser doesn't have a color scheme preference. Defaulting to dark theme.");
//         activateDarkTheme();
//     }
//     if (isNotSupported) {
//         console.log("Your browser doesn't support the color scheme preference media query. Please update to a more recent browser. Defaulting to dark theme.");
//         console.log("Or, hey, maybe you're using Tor or another privacy-aware browser. Keep doing that, then.");
//         activateDarkTheme();
//     }
// }

// function toggleTheme() {
//     if (document.documentElement.getAttribute("theme") === "dark") {
//         activateLightTheme();
//     } else if (document.documentElement.getAttribute("theme") === "light") {
//         activateDarkTheme();
//     } else {
//         console.log("Looks like something broke. Setting the theme to your browser's color scheme preference.");
//         activateColorScheme();
//     }
// }

// onLoad();
